// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiAgentsToolsResult = objectOf({
  tools: arrayOf(
    objectOf({
      id: number,
      name: string,
      functions: arrayOf(objectOf({ name: string, description: string })),
    })
  ),
  agents: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      daily_execution_count_limit: maybe(number),
      execution_usage: maybe(
        objectOf({
          limits: objectOf({ daily: maybe(number) }),
          current_usage: objectOf({ today: maybe(number) }),
        })
      ),
      include_all_canvas_context: maybe(boolean),
    })
  ),
});
